import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {PublicRoutes} from "../public.routes";
import {SigninComponent} from "./signin/signin.component";
import { OtpComponent } from './otp/otp.component';
import { ChangeMdpComponent } from './change-mdp/change-mdp.component';

const routes: Routes = [
  {
    title: "Signin",
    path: PublicRoutes.Signin,
    component: SigninComponent
  },
  {
    title: "Otp",
    path: PublicRoutes.Otp,
    component: OtpComponent
  },
  {
    title: "Mot de Passe Oublié",
    path: PublicRoutes.changeMdp,
    component: ChangeMdpComponent
  },
  // {
  //   title: "Signup",
  //   path: PublicRoutes.Signin,
  //   component: SigninComponent
  // },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthRoutingModule { }
